import Currency, { DEFAULT_VALUE } from './Currency';

export default Currency;
export { DEFAULT_VALUE };